// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_components_login_login_module_ts":"4de4586912c20223","src_app_components_my-account_my-account_module_ts":"f3f3468bb3856bd9"}[chunkId] + ".js";
};